( function ( _s ) {
	const createCardEl = html => {
		const placeholder = document.createElement( 'div' );
		placeholder.innerHTML = html;
		return placeholder.firstElementChild;
	};

	const objectToFormData = obj => {
		const formData = new FormData();

		Object.entries( obj ).forEach( ( [ key, value ] ) => {
			formData.append( key, value );
		} );

		return formData;
	};

	// Check if the entire bottom edge is within the viewport, considering element height
	const isElementBottomVisible = element => {
		const rect = element.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		return rect.bottom <= windowHeight;
	};

	const doAjax = ( _self, ajaxConfig ) => {
		if ( ( ajaxConfig.page !== 1 && _self.noMoreResults ) || _self.ajaxRunning ) return;

		//vars
		const _statusContainer = _self.find( '.ajax-status-container' );

		//set flag
		_self.ajaxRunning = true;
		_statusContainer.attr( 'ajax-status', 'ajax-running' );

		//emit events
		_self.trigger( 'fr:ajax-started' );

		//if page == 1, clean the container first
		if ( ajaxConfig.page && ajaxConfig.page === 1 ) {
			_self.find( '.card' ).remove();
			//reset flag(s)
			_self.noMoreResults = false;
		}

		//get data from AJAX
		fetchData( ajaxConfig, ( resp, err ) => {
			//set flags
			_statusContainer.attr( 'ajax-status', '' );
			_self.ajaxRunning = false;

			//emit events
			_self.trigger( 'fr:ajax-ended' );

			if ( err ) {
				console.log( err );
			} else if ( resp.success ) {
				resp.data.posts.forEach( card => {
					_statusContainer.before( createCardEl( card ) );
				} );

				if ( ajaxConfig.page === 1 && resp.data.posts.length === 0 ) {
					_statusContainer.attr( 'ajax-status', 'no-results-found' );
					_self.noMoreResults = true;
				}

				if ( resp.data.has_more === false && ajaxConfig.page !== 1 ) {
					_statusContainer.attr( 'ajax-status', 'no-more-results' );
					_self.noMoreResults = true;
				}

				if ( resp.data.posts.length ) {
					_self.trigger( 'fr:cards-added' );
					_self.trigger( 'fr:init-cards' );
				}
			}
		} );
	};

	const fetchData = ( ajaxConfig, callback ) => {
		const config = { ...ajaxConfig }; //make a copy to clean up later

		const fetchConfig = {
			url: config.url,
			method: config.method,
		};

		//clean obj
		[ 'url', 'method' ].forEach( prop => delete config[ prop ] );

		//parse config to update url/body
		if ( fetchConfig.method === 'GET' ) {
			fetchConfig.url += '?' + new URLSearchParams( config ).toString();
		} else if ( fetchConfig.method === 'POST' ) {
			fetchConfig.body = objectToFormData( config );
		}

		//handle request
		fetch( fetchConfig.url, fetchConfig )
			.then( response => response.json() )
			.then( data => callback( data ) )
			.catch( error => callback( null, error ) );
	};

	_s.fn.cardsContainer = function () {
		return this.each( el => {
			const _self = _s( el );

			if ( _self.el[ 0 ].hasAttribute( 'fr-ajax' ) ) {
				let ajaxConfig = JSON.parse( _self.attr( 'ajax-config' ) ) || {};
				_self.ajaxRunning = false;
				_self.noMoreResults = [ 'no-results-found', 'no-more-results' ].includes(
					_self.find( '.ajax-status-container' ).attr( 'ajax-status' ) || ''
				);

				//on page load set config
				_self.on( 'fr:set-ajax-config', e => {
					ajaxConfig = e.detail.config;
				} );

				_self.on( 'fr:do-ajax', e => {
					ajaxConfig = { ...ajaxConfig, ...e.detail.config };
					doAjax( _self, ajaxConfig );
				} );

				_s( window ).on( 'scroll', () => {
					if (
						! _self.ajaxRunning &&
						! _self.noMoreResults &&
						isElementBottomVisible( _self.el[ 0 ] )
					) {
						//load more
						ajaxConfig = { ...ajaxConfig, ...{ page: ( ajaxConfig.page || 1 ) + 1 } };
						doAjax( _self, ajaxConfig );
					}
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '.cards-container' ).cardsContainer();
	} );
} )( window._s );
